// extracted by mini-css-extract-plugin
export default {"title":"scratchClubHeader_title__Jw6li","titleRecord":"scratchClubHeader_titleRecord__4hvdg","navLink":"scratchClubHeader_navLink__6X03H","active":"scratchClubHeader_active__jM3ar"};